import * as Sentry from '@sentry/react';

const dsn = process.env.REACT_APP_SENTRY_DSN;
const release = process.env.REACT_APP_SENTRY_RELEASE;
const environment = process.env.REACT_APP_SENTRY_ENVIRONMENT || 'local';

export const loadSentry = process.env.NODE_ENV === 'production' && dsn && release;

export const initSentry = (history) => {
  if (!loadSentry) {
    return;
  }

  Sentry.init({
    dsn,
    release,
    environment,
    normalizeDepth: 3,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
    integrations: [
      new Sentry.BrowserTracing({
        routingInstrumentation: Sentry.reactRouterV5Instrumentation(history),
      }),
      new Sentry.Replay(),
    ],

    // We recommend adjusting this value in production, or using tracesSampler
    // for finer control
    tracesSampleRate: 1.0,
  });
};

export const sentryReduxEnhancer = () => Sentry.createReduxEnhancer({});
